import React from 'react';
import PropTypes from 'prop-types';

export class PortDetail extends React.Component {
  static propTypes = {
    destination: PropTypes.object.isRequired
  }
  render() {
    const { destination } = this.props;
    return (
      <div className='destination no-body'>
        <strong>{destination.title}</strong><br />
        <span className="thin description soft">{destination.description}</span>
      </div>
    )
  }
}

class Port extends React.Component {
  static propTypes = {
    destination: PropTypes.object.isRequired
  };

  render() {
    const { destination } = this.props;

    return (
      <div className='destination'>
        <div className="heading">
          <div className="grid flex">
            <div className="grid-cell self-middle">
              <strong>{destination.title}</strong>
              <span className="thin description soft">{destination.description}</span>
            </div>
            <div className="grid-cell self-middle btn-links sm">
              <a href={`/destinations/${destination.id}/edit`}>Settings</a>
              {' '}
              <a href={`/destinations/${destination.id}/filter`}>Log Filters</a>
            </div>
          </div>
        </div>

        <ul className="soft bullets">
          <li dangerouslySetInnerHTML={{ __html: destination.relatedSystems }} />
          <li dangerouslySetInnerHTML={{ __html: destination.groupLink }} />
          <li>{destination.autoadd}</li>
          <li>{destination.protocolDescription}</li>
          {destination.filterDisabled &&
            <li>
              <span className="red">
                <span className="flaticon solid slim"></span>
                <a className="red" href={`/destinations/${destination.id}/filter`}>Log filter has been disabled</a>
              </span>
            </li>
          }
          {!destination.filterDisabled && destination.filter && <li>Log filter active</li>}
          {!destination.filterDisabled && !destination.filter && destination.hasFilters && <li>Log filter inactive</li>}
        </ul>
      </div>
    );
  }
};

export default Port;
